export default "__VITE_ASSET__CLyus1_l__"